/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc). To make a column queryable by index — including boolean/nullable columns — add a single-column Postgres index and re-run `sf dc`; do not hand-edit generated files.
 */
/* eslint-disable complexity -- the generated converters branch per column; complexity scales with column count */
import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { MealBase } from 'shared/dbo/Meal';

export interface MealIndexedDb {
	id: string;
	mealTitle: string;
	rangeStartTime: string;
	rangeEndTime: string;
	validSunday: number;
	validMonday: number;
	validTuesday: number;
	validWednesday: number;
	validThursday: number;
	validFriday: number;
	validSaturday: number;
	created: number;
	lastModified: number;
	shortId: string;
}

const isMealIndexedDb1 = (
	obj: unknown
): obj is {
	id: string;
	mealTitle: string;
	rangeStartTime: string;
	rangeEndTime: string;
	validSunday: number;
	validMonday: number;
	validTuesday: number;
	validWednesday: number;
	validThursday: number;
	validFriday: number;
} => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ mealTitle: unknown }>(obj, 'mealTitle') || !(typeof obj.mealTitle === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ rangeStartTime: unknown }>(obj, 'rangeStartTime') || !(typeof obj.rangeStartTime === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ rangeEndTime: unknown }>(obj, 'rangeEndTime') || !(typeof obj.rangeEndTime === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ validSunday: unknown }>(obj, 'validSunday') || !(typeof obj.validSunday === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ validMonday: unknown }>(obj, 'validMonday') || !(typeof obj.validMonday === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ validTuesday: unknown }>(obj, 'validTuesday') || !(typeof obj.validTuesday === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ validWednesday: unknown }>(obj, 'validWednesday') || !(typeof obj.validWednesday === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ validThursday: unknown }>(obj, 'validThursday') || !(typeof obj.validThursday === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ validFriday: unknown }>(obj, 'validFriday') || !(typeof obj.validFriday === 'number')) {
		return false;
	}
	return true;
};

const isMealIndexedDb2 = (
	obj: unknown
): obj is {
	validSaturday: number;
	created: number;
	lastModified: number;
	shortId: string;
} => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!hasPropOfType<{ validSaturday: unknown }>(obj, 'validSaturday') || !(typeof obj.validSaturday === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const isMealIndexedDb = (obj: unknown): obj is MealIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!isMealIndexedDb1(obj)) {
		return false;
	}
	if (!isMealIndexedDb2(obj)) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: MealBase): MealIndexedDb => ({
	id: obj.id.toString(),
	mealTitle: obj.mealTitle,
	rangeStartTime: obj.rangeStartTime.toString(),
	rangeEndTime: obj.rangeEndTime.toString(),
	validSunday: obj.validSunday ? 1 : 0,
	validMonday: obj.validMonday ? 1 : 0,
	validTuesday: obj.validTuesday ? 1 : 0,
	validWednesday: obj.validWednesday ? 1 : 0,
	validThursday: obj.validThursday ? 1 : 0,
	validFriday: obj.validFriday ? 1 : 0,
	validSaturday: obj.validSaturday ? 1 : 0,
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: MealIndexedDb): MealBase => ({
	id: UUID.fromString(obj.id),
	mealTitle: obj.mealTitle,
	rangeStartTime: Temporal.PlainTime.from(obj.rangeStartTime),
	rangeEndTime: Temporal.PlainTime.from(obj.rangeEndTime),
	validSunday: obj.validSunday === 1,
	validMonday: obj.validMonday === 1,
	validTuesday: obj.validTuesday === 1,
	validWednesday: obj.validWednesday === 1,
	validThursday: obj.validThursday === 1,
	validFriday: obj.validFriday === 1,
	validSaturday: obj.validSaturday === 1,
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdMeal: LocalDatabaseTableDefinition<MealBase, MealIndexedDb> = {
	tableName: 'meals',
	indexColumns: [],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
